export enum FilesCategoryEnum {
  INSTRUMENTO_PUBLICO_CESSAO = "INSTRUMENTO_PUBLICO_CESSAO",    
  INSTRUMENTO_PUBLICO_MANDATO = "INSTRUMENTO_PUBLICO_MANDATO",
  TERMO_CESSAO = "TERMO_CESSAO",
  TERMO_CONDICOES_GERAIS = "TERMO_CONDICOES_GERAIS",
  TERMO_ACEITE = "TERMO_ACEITE",
  CAPA_DO_PROCESSO = "CAPA_DO_PROCESSO",
  SUBSTABELECIMENTO = "SUBSTABELECIMENTO",
  OUTROS = "OUTROS",
  ENTUBA_EXPOSURE_VALUE = "ENTUBA_EXPOSURE_VALUE",
  PRINCING_BATCH = "PRINCING_BATCH",
OFFICER_INSTRUCTIONS = "OFFICER_INSTRUCTIONS",
EXPENSE_BATCH = "EXPENSE_BATCH"
}

export const FilesCategoryEnumLabel = new Map<FilesCategoryEnum, string>([
  [FilesCategoryEnum.INSTRUMENTO_PUBLICO_CESSAO, "Instrumento publico de cessão"],
  [FilesCategoryEnum.INSTRUMENTO_PUBLICO_MANDATO, "Instrumento publico de mandato"],
  [FilesCategoryEnum.TERMO_CESSAO, "Termo de cessão"],
  [FilesCategoryEnum.TERMO_CONDICOES_GERAIS, "Termos e condições gerais"],
  [FilesCategoryEnum.TERMO_ACEITE, "Termo de aceite"],
  [FilesCategoryEnum.CAPA_DO_PROCESSO, "Capa do processo"],
  [FilesCategoryEnum.SUBSTABELECIMENTO, "Substabelecimento"],
  [FilesCategoryEnum.OUTROS, "Outros"],
  [FilesCategoryEnum.ENTUBA_EXPOSURE_VALUE, "Modelo de Entuba de Valor de Exposição"],
  [FilesCategoryEnum.PRINCING_BATCH, "Modelo de Precificação em Lote"],
  [FilesCategoryEnum.OFFICER_INSTRUCTIONS, "Manual de Instruções"],
  [FilesCategoryEnum.EXPENSE_BATCH, "Planilha modelo"]
]);



// WEBPACK FOOTER //
// ./src/services/Enum/FilesCategoryEnum.ts